const EVENT_TYPE_ALIASES = {
    assaig: 'assaig',
    assaigs: 'assaig',
    actuacio: 'actuacio',
    actuació: 'actuacio',
    actuacions: 'actuacio',
    activitat: 'activitat',
    activitats: 'activitat',
};

const EVENT_TYPE_SEGMENT = '(assaigs?|actuaci[oó]|actuacions|activitats?)';

export const normalizeEventDeepLinkType = eventType => {
    const normalized = String(eventType || '').trim().toLowerCase();
    return EVENT_TYPE_ALIASES[normalized] || null;
};

export const buildEventAppLink = ({ colla, eventType, eventId, baseUrl } = {}) => {
    const normalizedEventType = normalizeEventDeepLinkType(eventType);

    if (!colla || colla === 'none' || !normalizedEventType || eventId === undefined || eventId === null || eventId === '') {
        return null;
    }

    const publicBaseUrl = (baseUrl || `https://${colla}.tenimaleta.com`).replace(/\/+$/, '');
    return `${publicBaseUrl}/${normalizedEventType}/${encodeURIComponent(eventId)}`;
};

export const buildEventAppSchemeUrl = ({ colla, eventType, eventId } = {}) => {
    const normalizedEventType = normalizeEventDeepLinkType(eventType);

    if (!colla || colla === 'none' || !normalizedEventType || eventId === undefined || eventId === null || eventId === '') {
        return null;
    }

    return `aleta://${normalizedEventType}/${encodeURIComponent(eventId)}?colla=${encodeURIComponent(colla)}`;
};

export const parseEventAppLinkPath = pathname => {
    if (!pathname) return null;

    let decodedPath = pathname.split('?')[0].split('#')[0];

    try {
        decodedPath = decodeURIComponent(decodedPath);
    } catch (error) {}

    const match = decodedPath.match(new RegExp(`^/${EVENT_TYPE_SEGMENT}/(\\d+)/?$`, 'i'));
    if (!match) return null;

    const eventType = normalizeEventDeepLinkType(match[1]);
    if (!eventType) return null;

    return {
        eventType,
        eventId: match[2],
    };
};
